import { axiosConfig } from './axios-config.js'

// 個人設定
export const personalSetting = {
  // 搜尋住民
  searchResidents: (name, token) => {
    const config = Object.assign({}, token)
    config.params = { name }
    return axiosConfig.get('/api/residents/search', config)
  },
  
  // 取得住民個人設定
  getSettings: (residentId, token) => 
    axiosConfig.get(`/api/residents/${residentId}/personal-settings`, token),
  
  // 更新住民個人設定
  updateSettings: (residentId, data, token) =>
    axiosConfig.put(`/api/residents/${residentId}/personal-settings`, data, token)
}